// src/contexts/NavigationContext.js
import { createContext, useContext, useState } from 'react';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [scrollTarget, setScrollTarget] = useState(null);
  
  return (
    <NavigationContext.Provider value={{ scrollTarget, setScrollTarget }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  return useContext(NavigationContext);
};